import { Link } from "@tanstack/react-router";
import { ScanSearch, Blocks, Workflow, UsersRound, ArrowRight } from "lucide-react";

import Section from "@/components/Section";
import Container from "@/components/Container";
import Eyebrow from "@/components/Eyebrow";
import Reveal from "@/components/Reveal";
import { PathCard } from "@/components/home/PathCard";

const SERVICES = [
  {
    icon: ScanSearch,
    title: "AI Opportunity Assessment",
    body: "We map how your business runs and rank every place AI can unlock measurable value, by impact, effort, and time to payback.",
    to: "/services/ai-opportunity-assessment",
  },
  {
    icon: Blocks,
    title: "AI Implementation",
    body: "We build and deploy the systems the assessment identified, integrated with the tools your team already uses.",
    to: "/services/ai-implementation",
  },
  {
    icon: Workflow,
    title: "Workflow Automation",
    body: "Automate the repetitive operational work consuming your team's week, without ripping out the systems you already run.",
    to: "/services/workflow-automation",
  },
  {
    icon: UsersRound,
    title: "AI Enablement",
    body: "Training and change management so the systems you invested in are still in use six months later.",
    to: "/services/ai-enablement",
  },
] as const;

// The funding service pages are draft routes (src/lib/draft-routes.ts), so these
// are listed as plain text until those pages are finished.
const FUNDING_PRACTICES = [
  "SBA Loan Consulting",
  "Business Plan Writing",
  "Grants & Alternative Capital",
] as const;

export function ServicesGrid() {
  return (
    <Section tone="paper">
      <Container>
        <Reveal className="max-w-[52ch]">
          <Eyebrow>What we do</Eyebrow>
          <h2 className="mt-3 font-display text-h2 text-ink-900">Four ways we put AI to work.</h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2">
          {SERVICES.map((service, i) => (
            <Reveal key={service.title} delay={(i % 2) * 60} className="h-full">
              <PathCard {...service} cta="Learn more" />
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-8">
          <div className="rounded-xl border border-ink-200 bg-paper-100 px-6 py-7 sm:px-8">
            <span className="font-mono text-eyebrow uppercase font-medium tracking-[0.14em] text-ink-500">
              Also — Business funding
            </span>
            <p className="mt-3 measure text-body text-ink-600">
              We run a separate funding practice, whether you&rsquo;re financing an AI investment or
              raising capital for anything else.
            </p>
            <ul className="mt-5 flex flex-col gap-x-8 gap-y-3 text-body font-medium text-ink-700 sm:flex-row sm:flex-wrap sm:items-center">
              {FUNDING_PRACTICES.map((practice) => (
                <li key={practice}>{practice}</li>
              ))}
            </ul>
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}

export default ServicesGrid;
